var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action } from "mobx";
import { ErrorModel, BetModel, StakeButtonsStatusesModel } from "../models";
import { ErrorType, BetStatus } from "../enums";
export class Retriever {
    constructor(msgBus) {
        this.clearDataAction = () => {
            this.clearData();
        };
        this.messageBus = msgBus;
        this.betStatus = BetStatus.Default;
        this.bets = [];
        this.errors = [];
        this.purchases = [];
        this.freeBets = [];
        this.liveSelections = [];
        this.preliveSelections = [];
        this.isPlaceBetButtonEnabled = false;
        this.stakeButtonsStatus = Object.create({});
        this.getData = this.getData.bind(this);
        this.onMsgBusTopicReceived = this.onMsgBusTopicReceived.bind(this);
    }
    activate() {
        this.getData();
    }
    deactivate() {
        this.clearData();
        this.messageBus.unsubscribe("sb_yourbet_topic", this.onMsgBusTopicReceived);
    }
    getData() {
        this.messageBus.subscribe("sb_yourbet_topic", this.onMsgBusTopicReceived);
    }
    onMsgBusTopicReceived(topic) {
        if (topic) {
            Object.keys(topic).forEach(x => {
                let funcName = `${x}Topic`;
                if (this.checkIfFunction(funcName)) {
                    this[funcName](topic[x]);
                }
            }, this);
        }
    }
    actionsTopic(actions) {
        Object.keys(actions).forEach(x => {
            let funcName = `${x}Action`;
            if (this.checkIfFunction(funcName)) {
                this[funcName](actions[x]);
            }
        }, this);
    }
    purchaseAction(purchases) {
        this.purchases = this.toPurchaseModels(purchases);
    }
    errorAction(errors) {
        this.errors = this.toErrorModels(errors);
    }
    freeBetsAction(freeBets) {
        this.freeBets = freeBets;
    }
    placeBet(stake, selections) {
        let groupedSelections = this.getGroupedSelections(selections);
        let yourBetSelections = groupedSelections.live.concat(groupedSelections.prelive);
        let message = {
            actions: {
                place: {
                    stake,
                    selections: yourBetSelections
                }
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        return message;
    }
    selectFreeBet(freeBetId) {
        const message = {
            actions: {
                freeBetId
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        return message;
    }
    updateNewOfferStatus(waitingBetId, isAccepted) {
        let message = {
            actions: {
                newOfferStatus: {
                    waitingBetId,
                    isAccepted
                }
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        return message;
    }
    updateOddsChangeStatus(isAccepted) {
        let message = {
            actions: {
                oddsChangedStatus: {
                    isOddAccepted: isAccepted
                }
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        return message;
    }
    placeResultTopic(placeBetResponse) {
        this.purchaseResponse(placeBetResponse.purchase);
        this.selectionsResponse(placeBetResponse.selections, placeBetResponse.purchase);
        if (placeBetResponse.error) {
            this.errorResponse(placeBetResponse.error);
        }
    }
    ;
    purchaseResponse(purchases) {
        this.bets = this.getBets(purchases);
        this.betStatus = this.getPurchaseStatus(purchases);
        this.purchases = this.toPurchaseModels(purchases);
    }
    selectionsResponse(selections, purchases) {
        purchases.forEach(x => {
            if (x.liveSelectionIds) {
                let liveSelectionsToReplace = this.mapSelectionsToIds(x.liveSelectionIds, selections, true);
                if (liveSelectionsToReplace.length > 0) {
                    this.setCurrentSelections(liveSelectionsToReplace, true);
                }
            }
            if (x.preliveSelectionIds) {
                let preliveSelectionsToReplace = this.mapSelectionsToIds(x.preliveSelectionIds, selections, false);
                if (preliveSelectionsToReplace.length > 0) {
                    this.setCurrentSelections(preliveSelectionsToReplace, false);
                }
            }
        });
    }
    errorResponse(errors) {
        this.errors = this.toErrorModels(errors);
    }
    selectionsTopic(selections) {
        Object.keys(selections).forEach(x => {
            if (x === "live") {
                Object.keys(selections[x].selections).forEach(y => {
                    let funcName = `${y}SelectionsResponse`;
                    if (this.checkIfFunction(funcName)) {
                        this[funcName](selections[x].selections[y], true);
                    }
                }, this);
            }
            else {
                Object.keys(selections[x].selections).forEach(y => {
                    let funcName = `${y}SelectionsResponse`;
                    if (this.checkIfFunction(funcName)) {
                        this[funcName](selections[x].selections[y], false);
                    }
                }, this);
            }
        }, this);
    }
    addSelectionsResponse(selectionsToAdd, isLive) {
        if (selectionsToAdd && selectionsToAdd.length > 0) {
            let currentSelections = this.getCurrentSelections(isLive)
                .concat(selectionsToAdd.map(x => (Object.assign(Object.assign({}, x), { isLive }))));
            this.setCurrentSelections(currentSelections, isLive);
        }
    }
    updateSelectionsResponse(selectionsToUpdate, isLive) {
        if (selectionsToUpdate && selectionsToUpdate.length > 0) {
            let currentSelections = this.getCurrentSelections(isLive);
            selectionsToUpdate.forEach(x => {
                let indexToUpdate = currentSelections.findIndex(y => y.id === x.id);
                if (indexToUpdate >= 0) {
                    currentSelections[indexToUpdate] = Object.assign(Object.assign({}, x), { isLive });
                }
            });
        }
    }
    removeSelectionsResponse(selectionsToRemove, isLive) {
        if (selectionsToRemove && selectionsToRemove.length > 0) {
            let currentSelections = this.getCurrentSelections(isLive);
            currentSelections = currentSelections.reduce((a, b) => {
                let selection = selectionsToRemove.find(y => y.id === b.id);
                if (!selection) {
                    a.push(b);
                }
                return a;
            }, []);
            this.setCurrentSelections(currentSelections, isLive);
        }
    }
    removeSelectionsRequest(selections) {
        let result = this.getRemoveSelectionsRequestMessage({ live: [], prelive: [] });
        if (selections && selections.length > 0) {
            let groupedSelections = this.getGroupedSelections(selections);
            let message = this.getRemoveSelectionsRequestMessage(groupedSelections);
            this.messageBus.post({ sb_yourbet_topic: message });
            result = message;
        }
        return result;
    }
    retainPurchaseRequest(purchaseId, purchaseViewKey) {
        let message = {
            actions: {
                retainPurchase: {
                    purchaseId,
                    purchaseViewKey
                }
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        this.clearSelections();
        return message;
    }
    clearPurchaseRequest(purchaseId, purchaseViewKey) {
        let message = {
            actions: {
                clearPurchase: {
                    purchaseId,
                    purchaseViewKey
                }
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        this.clearSelections();
        return message;
    }
    clearAllPurchases(purchases) {
        let purchasesResult = purchases.reduce((a, purchase) => {
            if (purchase.id && purchase.viewKey) {
                let currentPurchase = {
                    purchaseId: purchase.id,
                    purchaseViewKey: purchase.viewKey
                };
                a.push(currentPurchase);
            }
            return a;
        }, []);
        let message = {
            actions: {
                clearAllPurchases: purchasesResult
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        this.clearSelections();
        return message;
    }
    clearSelections() {
        let message = this.getRemoveSelectionsRequestMessage({ live: this.liveSelections, prelive: this.preliveSelections });
        this.messageBus.post({ sb_yourbet_topic: message });
        this.betStatus = BetStatus.Default;
        this.liveSelections = [];
        this.preliveSelections = [];
        return message;
    }
    clearPurchaseAction(purchaseInfo) {
        this.purchases = this.purchases.reduce((a, purchase) => {
            if (purchase.viewKey && purchase.viewKey !== purchaseInfo.purchaseViewKey) {
                a.push(purchase);
            }
            return a;
        }, []);
        this.betStatus = BetStatus.Default;
        this.liveSelections = [];
        this.preliveSelections = [];
    }
    changeStake(stake, buttonAction) {
        let stakeMessage = { value: stake };
        if (buttonAction) {
            stakeMessage = {
                value: stake,
                [buttonAction]: true
            };
        }
        let message = {
            actions: {
                stake: stakeMessage
            }
        };
        this.messageBus.post({ sb_yourbet_topic: message });
        return message;
    }
    stakeButtonsStatesAction(obj) {
        this.stakeButtonsStatus = new StakeButtonsStatusesModel({
            plusEnabled: obj.plusEnabled || false,
            minusEnabled: obj.minusEnabled || false
        });
        return this.stakeButtonsStatus;
    }
    placeBetButtonStateAction(obj) {
        this.isPlaceBetButtonEnabled = obj.isEnabled || false;
        return this.isPlaceBetButtonEnabled;
    }
    getGroupedSelections(selections) {
        let groupedSelections = selections.reduce((grouped, selection) => {
            let currentSelection = {
                id: selection.id,
                name: selection.name,
                viewKey: selection.viewKey,
                eventType: selection.eventType,
                suspended: selection.suspended
            };
            if (selection.isLive) {
                grouped.live.push(currentSelection);
            }
            else {
                grouped.prelive.push(currentSelection);
            }
            return grouped;
        }, { live: [], prelive: [] });
        return groupedSelections;
    }
    getRemoveSelectionsRequestMessage(groupedSelections) {
        return {
            selections: {
                live: {
                    selections: {
                        remove: groupedSelections.live
                    }
                },
                prelive: {
                    selections: {
                        remove: groupedSelections.prelive
                    }
                }
            }
        };
    }
    getBets(purchases) {
        let result = [];
        purchases.forEach(purchase => {
            if (purchase && purchase.bet && purchase.bet.id) {
                let betToAdd = new BetModel({ id: purchase.bet.id });
                result.push(betToAdd);
            }
        });
        return result;
    }
    getPurchaseStatus(purchases) {
        let resultStatus = 0;
        purchases.forEach(purchase => {
            if (purchase && purchase.status) {
                Object.keys(purchase.status).forEach(key => {
                    if (purchase.status[key]) {
                        resultStatus = this.getStatus(key);
                    }
                }, this);
            }
        }, this);
        return resultStatus;
    }
    getStatus(statusKey) {
        const status = {
            accepted: BetStatus.Accepted,
            rejected: BetStatus.Rejected,
            waiting: BetStatus.Waiting,
            newOffer: BetStatus.NewOffer
        };
        return status[statusKey] || BetStatus.Default;
    }
    toPurchaseModels(purchases) {
        let newPurchases = purchases.reduce((result, purchase) => {
            let indexToUpdate = this.purchases.findIndex(y => y.id === purchase.id);
            if (indexToUpdate !== -1) {
                let purchaseToUpdate = Object.assign({}, this.purchases[indexToUpdate]);
                Object.keys(purchase).forEach(key => {
                    if (purchase[key] !== undefined && purchase[key] !== null) {
                        purchaseToUpdate[key] = purchase[key];
                    }
                });
                result.push(purchaseToUpdate);
            }
            else {
                result.push(purchase);
            }
            return result;
        }, []);
        return newPurchases;
    }
    mapSelectionsToIds(selectionIds, selections, isLive) {
        let resultSelections = [];
        selectionIds.forEach(x => {
            let selection = selections.find(y => y.id === x);
            if (selection) {
                resultSelections.push(Object.assign(Object.assign({}, selection), { isLive }));
            }
        });
        return resultSelections;
    }
    toErrorModels(errors) {
        let errorResult = errors.reduce((result, error) => {
            let errorModel = new ErrorModel({});
            Object.keys(error).forEach(key => {
                if (key !== ErrorType.ActivationError
                    && key !== ErrorType.DeactivationError) {
                    errorModel[key] = error[key];
                }
            });
            result.push(errorModel);
            return result;
        }, []);
        return errorResult;
    }
    setCurrentSelections(newSelections, isLive) {
        if (isLive) {
            this.liveSelections = newSelections;
        }
        else {
            this.preliveSelections = newSelections;
        }
    }
    clearData() {
        this.bets = [];
        this.errors = [];
        this.purchases = [];
        this.freeBets = observable([]);
        this.stakeButtonsStatus = Object.create({});
        this.clearSelections();
    }
    getCurrentSelections(isLive) {
        if (isLive) {
            return this.liveSelections;
        }
        else {
            return this.preliveSelections;
        }
    }
    checkIfFunction(functionName) {
        if (this[functionName] && typeof this[functionName] === "function") {
            return true;
        }
        else {
            return false;
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], Retriever.prototype, "betStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Retriever.prototype, "bets", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Retriever.prototype, "errors", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Retriever.prototype, "purchases", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Retriever.prototype, "freeBets", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Retriever.prototype, "liveSelections", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], Retriever.prototype, "preliveSelections", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Retriever.prototype, "stakeButtonsStatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], Retriever.prototype, "isPlaceBetButtonEnabled", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "actionsTopic", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "purchaseAction", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "errorAction", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "freeBetsAction", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "placeResultTopic", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "purchaseResponse", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Array]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "selectionsResponse", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "errorResponse", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "selectionsTopic", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "addSelectionsResponse", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "updateSelectionsResponse", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "removeSelectionsResponse", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "retainPurchaseRequest", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Number]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "clearPurchaseRequest", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "clearAllPurchases", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "clearSelections", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "clearPurchaseAction", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "stakeButtonsStatesAction", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "placeBetButtonStateAction", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Boolean]),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "setCurrentSelections", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Retriever.prototype, "clearData", null);
//# sourceMappingURL=Retriever.js.map